import { DatabaseModal } from './DatabaseModal'
import { DatabaseProvider } from './DatabaseProvider'

export function DatabaseModalV2() {
  return (
    <DatabaseProvider>
      <DatabaseModal />
    </DatabaseProvider>
  )
}
